import React, { useState, useEffect } from "react";
import Producto from "./Producto";
import { dbApp } from "../../firebase/config";
import Cargando from "../Cargando";
import Mensaje from "../Mensaje";

const ProductoInicio = () => {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    const getProductos = () => {
      setCargando(true);
      const resultadoProductos = [];
      dbApp
        .collection("pizzas")
        .where("ubicacion", "==", "INICIO")
        .get()
        .then(response => {
          setCargando(false);
          response.forEach(doc => {
            const producto = doc.data();
            producto.id = doc.id;
            resultadoProductos.push(producto);
          });
          setProductos(resultadoProductos);
        })
        .catch(() => {
          setCargando(false);
        });
    };

    getProductos();
  }, []);

  let mostrar;

  if (cargando) {
    mostrar = <Cargando />;
  } else if (productos.length <= 0) {
    mostrar = (
      <div className="mt-5">
        <Mensaje mensaje="No hay pizzas." />
      </div>
    );
  } else {
    mostrar = (
      <div className="card-deck">
        {productos.map(producto => (
          <Producto key={producto.id} producto={producto} />
        ))}
      </div>
    );
  }

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-center">
        <h2 className="titulo">ELIGE TU PIZZA</h2>
      </div>
      {mostrar}
    </div>
  );
};

export default ProductoInicio;
